import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";

const AddEquipment = (props) => {
  const { equipmentDetails, closeEditEquipmentPopUpCallback } = props;
  const [equipmentName, setEquipmentName] = useState("");
  const { localization } = useLanguageContext();

  // useEffect( () => {
  // 	setEquipmentName( equipmentDetails ? equipmentDetails : "" );
  // },[props])

  const equipmentAdd = (e) => {
    e.preventDefault();
  };

  return (
    <div
      className="modal fade"
      id="addEquipment"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addEquipment"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addEquipment">
              {equipmentDetails ? "Edit Equipment" : "Add Equipment"}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addEquipmentModalClose"
              onClick={closeEditEquipmentPopUpCallback}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form id="equipmentAdd" autoComplete="off" onSubmit={equipmentAdd}>
              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="equipment">
                  Equipment Name
                </label>
                <input
                  type="text"
                  id="equipment"
                  name="equipment"
                  className="form-control"
                  required
                  placeholder="Equipment Name"
                  value={equipmentName}
                  onChange={(e) => {
                    setEquipmentName(e.target.value);
                  }}
                />
              </div>

              <button type="submit" className="btn btn-primary btn-block mb-4">
                {localization.save}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEquipment;
